export default "__VITE_ASSET__zWd$Isix__"